import { render } from "./Formatting.vue?vue&type=template&id=324a7e2a"
import script from "./Formatting.vue?vue&type=script&lang=js"
export * from "./Formatting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__